import { createSlice } from '@reduxjs/toolkit';

// Type
import { IInitialState } from './type';

const omitKey = (obj: Record<string, any>, key: string) =>
	Object.fromEntries(Object.entries(obj).filter(([k]) => k !== key));

const recentSearchList = JSON.parse(
	(localStorage.getItem('recentSearchList') || '[]') as string
) || [];

const historyStructureSearch = JSON.parse(
	localStorage.getItem('structureList') || '[]'
) || [];

const recentBioSearchList = JSON.parse(
	localStorage.getItem('recentBioSearchList') || '[]'
);

const initialStateStructureKeyBoard = {
	size: 5,
	number: 0,
	content: [],
	totalPages: 1,
	totalElements: 0
};

const resultsOverview = {
	inputIds: 0,
	notFoundIds: []
};

const initialStateStructureSearch = {
	size: 10,
	number: 0,
	content: [],
	totalPages: 1,
	totalElements: 0
};

const initialStateGoTo = {
	goTo: 1
};

export const initialStateDataKeyBoard = {
	drugs: initialStateStructureKeyBoard,
	libraries: initialStateStructureKeyBoard,
	compounds: initialStateStructureKeyBoard,
	impurities: initialStateStructureKeyBoard,
	chemicalProbes: initialStateStructureKeyBoard
};

const searchDataKeyBoard = {
	drugs: initialStateGoTo,
	libraries: initialStateGoTo,
	compounds: initialStateGoTo,
	impurities: initialStateGoTo
};

const initialState: IInitialState = {
	searchTextSuggestResults: {
		drugs: [],
		libraries: [],
		compounds: [],
		impurities: [],
		chemicalProbes: []
	},
	searchTextResults: {
		type: 'compounds',
		searchDataKeyBoardGoTo: searchDataKeyBoard,
		...initialStateDataKeyBoard
	},
	searchDataKeyBoard: {
		type: 'compounds',
		searchDataKeyBoardGoTo: searchDataKeyBoard,
		...initialStateDataKeyBoard
	},
	searchTextView: {
		value: '',
		message: '',
		loading: false,
		typeMessage: '',
		currentValue: '',
		isHiddenDropdown: false,
		isShowTextSearch: false
	},

	searchListByIdsResult: {
		type: 'compounds',
		resultsOverview: resultsOverview,
		searchDataKeyBoardGoTo: omitKey(searchDataKeyBoard, 'libraries'),
		...omitKey(initialStateDataKeyBoard, 'libraries')
	},
	searchListByIds: {
		type: 'compounds',
		resultsOverview: resultsOverview,
		searchDataKeyBoardGoTo: omitKey(searchDataKeyBoard, 'libraries'),
		...omitKey(initialStateDataKeyBoard, 'libraries')
	},
	searchListByIdsView: {
		typeListById: '',
		valueListById: '',
		messageListById: '',
		loadingListById: false,
		isShowTextSearchListByIds: false
	},

	isSearch: false,
	toggleFilter: false,
	isShowTextSearch: false,
	recentSearchList: recentSearchList,
	recentBioSearchList: recentBioSearchList,
	historyStructureSearch: historyStructureSearch,
	price: {
		value: 0,
		label: ''
	},
	structureSearch: {
		structureType: 'compounds',
		structureData: {
			linkers: initialStateStructureSearch,
			compounds: initialStateStructureSearch
		},
		structureGoTo: {
			linkers: initialStateGoTo,
			compounds: initialStateGoTo
		},
		structureLoading: {
			loadingProtac: false,
			loadingLinkers: false,
			loadingCompounds: false
		}
	},
	marvinStructure: '',

	loadingDrugsTab: false,
	loadingCompoundsTab: false,
	loadingLibrariesTab: false,
	loadingImpuritiesTab: false,
	loadingChemicalProbesTab: false,

	loadingDrugsListByIdsTab: false,
	loadingCompoundsListByIdsTab: false,
	loadingImpuritiesListByIdsTab: false,
	loadingChemicalProbesListByIdsTab: false,

	loadingDownloadSDF: false,

	bioSearchForm: {
		value: '',
		disabled: false,
	},
};

export const searchSlice = createSlice({
	name: 'search',
	initialState,
	reducers: {
		updateMarvinStructure: (state, action) => {
			state.marvinStructure = action.payload;
		},

		handleChangeInputBioSearch: (state, action) => {
			state.bioSearchForm.value = action.payload;
		},
		handleChangeDisabledBioSearch: (state, action) => {
			state.bioSearchForm.disabled = action.payload;
		},

		downloadSDF: (state, action) => {
			state.loadingDownloadSDF = true;
		},
		downloadSDFError: (state) => {
			state.loadingDownloadSDF = false;
		},
		downloadSDFSuccess: (state) => {
			state.loadingDownloadSDF = false;
		},

		isShowTextSearch: (state, action) => {
			state.isShowTextSearch = action.payload;
		},

		changeToggleFilter: (state) => {
			state.toggleFilter = !state.toggleFilter;
		},
		handlerChangeStructureGoTo: (state, action) => {
			const type = action.payload.type;

			state.structureSearch.structureGoTo[type].goTo = action.payload.goTo;
		},

		handlerChangeSearchKeyBoardGoTo: (state, action) => {
			const type = action.payload.type;

			// @ts-ignore
			state.searchDataKeyBoard.searchDataKeyBoardGoTo[type].goTo = action.payload.goTo;
			// @ts-ignore
			state.searchTextResults.searchDataKeyBoardGoTo[type].goTo = action.payload.goTo;
		},

		handlerChangeSearchKeyBoardSize: (state, action) => {
			const type = action.payload.type;
			// @ts-ignore
			state.searchDataKeyBoard[type].size = action.payload.size;
			// @ts-ignore
			state.searchTextResults[type].size = action.payload.size;
		},

		handlerChangeStructureSize: (state, action) => {
			const type = action.payload.type;

			state.structureSearch.structureData[type].size = action.payload.size;
		},
		handlerChangeIsSearch: (state, action) => {
			state.isSearch = action.payload;
		},
		handlerChangeTypeStructure: (state, action) => {
			if (state.structureSearch?.structureType) {
				state.structureSearch.structureType = action.payload;
			}
		},

		compoundsSimilarity: (state, action) => {
			if (state.structureSearch) {
				state.structureSearch.structureLoading.loadingCompounds = true;
			}
		},
		compoundsSimilarityError: (state) => {
			if (state.structureSearch) {
				state.structureSearch.structureLoading.loadingCompounds = false;
			}
		},
		compoundsSimilaritySuccess: (state, action) => {
			if (state.structureSearch) {
				state.structureSearch.structureLoading.loadingCompounds = false;
				state.structureSearch.structureData.compounds = action.payload;
			}
		},

		compoundsSubstructure: (state, action) => {
			if (state.structureSearch) {
				state.structureSearch.structureLoading.loadingCompounds = true;
			}
		},
		compoundsSubstructureError: (state) => {
			if (state.structureSearch) {
				state.structureSearch.structureLoading.loadingCompounds = false;
			}
		},
		compoundsSubstructureSuccess: (state, action) => {
			if (state.structureSearch) {
				state.structureSearch.structureLoading.loadingCompounds = false;
				state.structureSearch.structureData.compounds = action.payload;
			}
		},

		compoundsFullfragment: (state, action) => {
			if (state.structureSearch) {
				state.structureSearch.structureLoading.loadingCompounds = true;
			}
		},
		compoundsFullfragmentError: (state) => {
			if (state.structureSearch) {
				state.structureSearch.structureLoading.loadingCompounds = false;
			}
		},
		compoundsFullfragmentSuccess: (state, action) => {
			state.structureSearch.structureLoading.loadingCompounds = false;

			state.structureSearch.structureData.compounds = action.payload;
		},

		linkersSubstructure: (state, action) => {
			state.structureSearch.structureLoading.loadingLinkers = true;
		},
		linkersSubstructureError: (state) => {
			state.structureSearch.structureLoading.loadingLinkers = false;
		},
		linkersSubstructureSuccess: (state, action) => {
			state.structureSearch.structureLoading.loadingLinkers = false;

			state.structureSearch.structureData.linkers = action.payload;
		},

		linkersSimilarity: (state, action) => {
			state.structureSearch.structureLoading.loadingLinkers = true;
		},
		linkersSimilarityError: (state) => {
			state.structureSearch.structureLoading.loadingLinkers = false;
		},
		linkersSimilaritySuccess: (state, action) => {
			state.structureSearch.structureLoading.loadingLinkers = false;

			state.structureSearch.structureData.linkers = action.payload;
		},

		linkersFullfragment: (state, action) => {
			state.structureSearch.structureLoading.loadingLinkers = true;
		},
		linkersFullfragmentError: (state) => {
			state.structureSearch.structureLoading.loadingLinkers = false;
		},
		linkersFullfragmentSuccess: (state, action) => {
			state.structureSearch.structureLoading.loadingLinkers = false;

			state.structureSearch.structureData.linkers = action.payload;
		},

		getStructureSearch: (state, action) => {
			const isClearState = action.payload.isClearState;
			if (isClearState) {
				state.structureSearch.structureData.linkers = initialState.structureSearch.structureData.linkers;
				state.structureSearch.structureData.compounds = initialState.structureSearch.structureData.compounds;
			}
		},
		getStructureSearchError: (state) => {
		},
		getStructureSearchSuccess: (state) => {
		},

		updateSearchTextData: (state) => {
			// @ts-ignore
			state.searchTextResults = state.searchDataKeyBoard;
		},

		handlerChangePriceCartCompound: (state, action) => {
			state.price = action.payload;
		},

		// Actions screen search text by ids
		handlerChangeSearchKeyBoardGoToListByIs: (state, action) => {
			const type = action.payload.type;

			// @ts-ignore
			state.searchListByIds.searchDataKeyBoardGoTo[type].goTo = action.payload.goTo;

			// @ts-ignore
			state.searchListByIdsResult.searchDataKeyBoardGoTo[type].goTo = action.payload.goTo;
		},
		handlerChangeSearchKeyBoardSizeListByIds: (state, action) => {
			const type = action.payload.type;
			// @ts-ignore
			const totalPages = Math.ceil(state.searchListByIds[type].content?.length / action.payload.size);

			// @ts-ignore
			state.searchListByIds[type].size = action.payload.size;
			// @ts-ignore
			state.searchListByIdsResult[type].size = action.payload.size;

			// @ts-ignore
			state.searchListByIds[type].totalPages = totalPages;
			// @ts-ignore
			state.searchListByIdsResult[type].totalPages = totalPages;
		},

		updateSearchByIdsData: (state) => {
			// @ts-ignore
			state.searchListByIdsResult = state.searchListByIds;
		},

		clearResultsOverview: (state) => {
			if (state.searchListByIds) {
				state.searchListByIds.resultsOverview = resultsOverview;
			}

			if (state.searchListByIdsResult) {
				state.searchListByIdsResult.resultsOverview = resultsOverview;
			}
		},

		searchTextUpdateByIds: (state, action) => {
			state.searchListByIdsView.valueListById = action.payload;
		},

		handleShowTextSearchListByIds: (state, action) => {
			state.searchListByIdsView.isShowTextSearchListByIds = action.payload;
		},

		searchTextByIds: (state, action) => {
			state.loadingListById = true;
			state.searchListByIdsView.valueListById = action.payload.value;

			state.typeListById = '';
			state.messageListById = '';
		},
		searchTextByIdsError: (state, action) => {
			state.loadingListById = false;
			state.typeListById = action.payload.type;
			state.messageListById = action.payload.message;
		},
		searchTextByIdsSuccess: (state) => {
			state.loadingListById = false;
			state.typeListById = '';
			state.messageListById = '';
		},

		searchTextByIdsDrugSuccess: (state, action) => {
			const data = action.payload.data;
			const resultsOverview = action.payload.resultsOverview;

			state.loadingListById = false;
			state.loadingDrugsListByIdsTab = false;
			state.searchListByIds = {
				...state.searchListByIds,
				drugs: data,
				resultsOverview: resultsOverview
			};

			state.typeListById = '';
			state.messageListById = '';
		},
		searchTextByIdsCompoundsSuccess: (state, action) => {
			const data = action.payload.data;
			const resultsOverview = action.payload.resultsOverview;

			state.loadingListById = false;
			state.loadingCompoundsListByIdsTab = false;
			state.searchListByIds = {
				...state.searchListByIds,
				compounds: data,
				resultsOverview: resultsOverview
			};

			state.typeListById = '';
			state.messageListById = '';
		},
		searchTextByIdsImpuritiesSuccess: (state, action) => {
			const data = action.payload.data;
			const resultsOverview = action.payload.resultsOverview;

			state.loadingListById = false;
			state.loadingImpuritiesListByIdsTab = false;
			state.searchListByIds = {
				...state.searchListByIds,
				impurities: data,
				resultsOverview: resultsOverview
			};

			state.typeListById = '';
			state.messageListById = '';
		},
		searchTextByIdsChemicalProbesSuccess: (state, action) => {
			const data = action.payload.data;
			const resultsOverview = action.payload.resultsOverview;

			state.loadingListById = false;
			state.loadingChemicalProbesListByIdsTab = false;
			state.searchListByIds = {
				...state.searchListByIds,
				chemicalProbes: data,
				resultsOverview: resultsOverview
			};

			state.typeListById = '';
			state.messageListById = '';
		},

		searchTextByIdsDrugLoadingTab: (state) => {
			state.loadingDrugsListByIdsTab = true;
		},
		searchTextByIdsCompoundsLoadingTab: (state) => {
			state.loadingCompoundsListByIdsTab = true;
		},
		searchTextByIdsImpuritiesLoadingTab: (state) => {
			state.loadingImpuritiesListByIdsTab = true;
		},
		searchTextByIdsChemicalProbesLoadingTab: (state) => {
			state.loadingChemicalProbesListByIdsTab = true;
		},

		handlerChangePageCompoundByIds: (state, action) => {
			if (state.searchListByIds && state.searchListByIds.compounds) {
				state.searchListByIds.compounds.number = action.payload;
			}
			if (state.searchListByIdsResult && state.searchListByIdsResult.compounds) {
				state.searchListByIdsResult.compounds.number = action.payload;
			}
		},
		handlerChangePageDrugsByIds: (state, action) => {
			if (state.searchListByIds && state.searchListByIds.drugs) {
				state.searchListByIds.drugs.number = action.payload;
			}
			if (state.searchListByIdsResult && state.searchListByIdsResult.drugs) {
				state.searchListByIdsResult.drugs.number = action.payload;
			}
		},
		handlerChangePageImpuritiesByIds: (state, action) => {
			if (state.searchListByIds && state.searchListByIds.impurities) {
				state.searchListByIds.impurities.number = action.payload;
			}
			if (state.searchListByIdsResult && state.searchListByIdsResult.impurities) {
				state.searchListByIdsResult.impurities.number = action.payload;
			}
		},
		handlerChangePageChemicalProbesByIds: (state, action) => {
			if (state.searchListByIds && state.searchListByIds.chemicalProbes) {
				state.searchListByIds.chemicalProbes.number = action.payload;
			}
			if (state.searchListByIdsResult && state.searchListByIdsResult.chemicalProbes) {
				state.searchListByIdsResult.chemicalProbes.number = action.payload;
			}
		},

		// Actions screen search text
		updateSearchText: (state, action) => {
			state.searchTextView.value = action.payload;
		},
		searchText: (state, action) => {
			state.searchTextView.loading = true;
			state.searchTextView.value = action.payload.value;

			state.searchTextView.typeMessage = '';
			state.searchTextView.message = '';
		},
		searchTextError: (state, action) => {
			state.searchTextView.loading = false;
			state.searchTextView.typeMessage = action.payload.type;
			state.searchTextView.message = action.payload.message;
		},
		searchTextSuccess: (state, action) => {
			const data = action.payload.data;
			const type = action.payload.type;

			state.searchTextView.loading = false;
			state.searchDataKeyBoard = {
				...state.searchDataKeyBoard,
				[type]: data
			};

			state.searchTextView.typeMessage = '';
			state.searchTextView.message = '';
		},

		handleCurrentValue: (state, action) => {
			state.searchTextView.currentValue = action.payload;
		},
		handleHiddenDropdown: (state, action) => {
			state.searchTextView.isHiddenDropdown = action.payload;
		},
		handleShowTextSearch: (state, action) => {
			state.searchTextView.isShowTextSearch = action.payload;
		},

		searchTextDrugSuccess: (state, action) => {
			const data = action.payload;

			state.searchTextView.loading = false;
			state.loadingDrugsTab = false;
			state.searchDataKeyBoard = {
				...state.searchDataKeyBoard,
				drugs: data
			};

			state.searchTextSuggestResults = {
				...state.searchTextSuggestResults,
				drugs: data.content
			};

			state.searchTextView.typeMessage = '';
			state.searchTextView.message = '';
		},
		searchTextLibrariesSuccess: (state, action) => {
			const data = action.payload;

			state.searchTextView.loading = false;
			state.loadingLibrariesTab = false;
			state.searchDataKeyBoard = {
				...state.searchDataKeyBoard,
				libraries: data
			};

			state.searchTextSuggestResults = {
				...state.searchTextSuggestResults,
				libraries: data.content
			};

			state.searchTextView.typeMessage = '';
			state.searchTextView.message = '';
		},
		searchTextCompoundsSuccess: (state, action) => {
			const data = action.payload;

			state.searchTextView.loading = false;
			state.loadingCompoundsTab = false;
			state.searchDataKeyBoard = {
				...state.searchDataKeyBoard,
				compounds: data
			};

			state.searchTextSuggestResults = {
				...state.searchTextSuggestResults,
				compounds: data.content
			};

			state.searchTextView.typeMessage = '';
			state.searchTextView.message = '';
		},
		searchTextImpuritiesSuccess: (state, action) => {
			const data = action.payload;

			state.searchTextView.loading = false;
			state.loadingImpuritiesTab = false;
			state.searchDataKeyBoard = {
				...state.searchDataKeyBoard,
				impurities: data
			};

			state.searchTextSuggestResults = {
				...state.searchTextSuggestResults,
				impurities: data.content
			};

			state.searchTextView.typeMessage = '';
			state.searchTextView.message = '';
		},
		searchTextChemicalProbesSuccess: (state, action) => {
			const data = action.payload;

			state.searchTextView.loading = false;
			state.loadingChemicalProbesTab = false;
			state.searchDataKeyBoard = {
				...state.searchDataKeyBoard,
				chemicalProbes: data
			};

			state.searchTextSuggestResults = {
				...state.searchTextSuggestResults,
				chemicalProbes: data.content
			};

			state.searchTextView.typeMessage = '';
			state.searchTextView.message = '';
		},

		searchTextDrugLoadingTab: (state) => {
			state.loadingDrugsTab = true;
		},
		searchTextLibrariesLoadingTab: (state) => {
			state.loadingLibrariesTab = true;
		},
		searchTextCompoundsLoadingTab: (state) => {
			state.loadingCompoundsTab = true;
		},
		searchTextImpuritiesLoadingTab: (state) => {
			state.loadingImpuritiesTab = true;
		},
		searchTextChemicalProbesLoadingTab: (state) => {
			state.loadingChemicalProbesTab = true;
		},

		handlerChangeTypeData: (state, action) => {
			if (state?.searchDataKeyBoard) {
				state.searchDataKeyBoard.type = action.payload;
			}

			if (state?.searchTextResults) {
				state.searchTextResults.type = action.payload;
			}
		},
		handlerChangeTypeDataListByIds: (state, action) => {
			if (state?.searchListByIds) {
				state.searchListByIds.type = action.payload;
			}
			if (state?.searchListByIdsResult) {
				state.searchListByIdsResult.type = action.payload;
			}
		},

		handleChangeStructurePageEbc: (state, action) => {
			if (state.structureSearch?.structureData) {
				// @ts-ignore
				state.structureSearch.structureData.compounds.number = action.payload;
			}
		},
		handleChangeStructurePageLinkers: (state, action) => {
			if (state.structureSearch?.structureData) {
				// @ts-ignore
				state.structureSearch.structureData.linkers.number = action.payload;
			}
		},

		handlerChangePageLib: (state, action) => {
			if (state.searchDataKeyBoard && state.searchDataKeyBoard.libraries) {
				state.searchDataKeyBoard.libraries.number = action.payload;
			}

			if (state.searchTextResults && state.searchTextResults.libraries) {
				state.searchTextResults.libraries.number = action.payload;
			}
		},
		handlerChangePageCompound: (state, action) => {
			if (state.searchDataKeyBoard && state.searchDataKeyBoard.compounds) {
				state.searchDataKeyBoard.compounds.number = action.payload;
			}

			if (state.searchTextResults && state.searchTextResults.compounds) {
				state.searchTextResults.compounds.number = action.payload;
			}
		},
		handlerChangePageDrugs: (state, action) => {
			if (state.searchDataKeyBoard && state.searchDataKeyBoard.drugs) {
				state.searchDataKeyBoard.drugs.number = action.payload;
			}

			if (state.searchTextResults && state.searchTextResults.drugs) {
				state.searchTextResults.drugs.number = action.payload;
			}
		},
		handlerChangePageImpurities: (state, action) => {
			if (state.searchDataKeyBoard && state.searchDataKeyBoard.impurities) {
				state.searchDataKeyBoard.impurities.number = action.payload;
			}

			if (state.searchTextResults && state.searchTextResults.impurities) {
				state.searchTextResults.impurities.number = action.payload;
			}
		},
		handlerChangePageChemicalProbes: (state, action) => {
			if (state.searchDataKeyBoard && state.searchDataKeyBoard.chemicalProbes) {
				state.searchDataKeyBoard.chemicalProbes.number = action.payload;
			}

			if (state.searchTextResults && state.searchTextResults.chemicalProbes) {
				state.searchTextResults.chemicalProbes.number = action.payload;
			}
		},

		historyList: (state, action) => {
			const name = action?.payload?.storeName;
			// @ts-ignore
			state[name] = action?.payload?.data;
		},
		updateHistoryStructureSearch: (state, action) => {
			state.historyStructureSearch = action.payload;
		},
		deleteItemStructureHistory: (state, action) => {
		}
	}
});

export const {
	updateMarvinStructure,

	handleChangeInputBioSearch,
	handleChangeDisabledBioSearch,

	handleCurrentValue,
	handleHiddenDropdown,
	handleShowTextSearch,

	updateSearchTextData,
	updateSearchByIdsData,

	clearResultsOverview,

	downloadSDF,
	downloadSDFError,
	downloadSDFSuccess,

	searchTextUpdateByIds,
	searchTextByIdsSuccess,

	handlerChangeSearchKeyBoardSizeListByIds,

	handlerChangePageCompoundByIds,
	handlerChangePageDrugsByIds,
	handlerChangePageImpuritiesByIds,
	handlerChangePageChemicalProbesByIds,

	handlerChangeTypeDataListByIds,
	handleShowTextSearchListByIds,

	searchTextByIdsDrugLoadingTab,
	searchTextByIdsCompoundsLoadingTab,
	searchTextByIdsImpuritiesLoadingTab,
	searchTextByIdsChemicalProbesLoadingTab,

	searchTextByIdsDrugSuccess,
	searchTextByIdsCompoundsSuccess,
	searchTextByIdsImpuritiesSuccess,
	searchTextByIdsChemicalProbesSuccess,

	searchTextByIds,
	searchTextByIdsError,

	isShowTextSearch,

	changeToggleFilter,

	handlerChangeStructureSize,
	handlerChangeSearchKeyBoardSize,

	handlerChangeSearchKeyBoardGoTo,
	handlerChangeSearchKeyBoardGoToListByIs,
	handlerChangeStructureGoTo,

	searchTextDrugLoadingTab,
	searchTextLibrariesLoadingTab,
	searchTextCompoundsLoadingTab,
	searchTextImpuritiesLoadingTab,
	searchTextChemicalProbesLoadingTab,

	handlerChangeIsSearch,

	updateSearchText,
	searchText,
	searchTextError,

	searchTextDrugSuccess,
	searchTextCompoundsSuccess,
	searchTextLibrariesSuccess,
	searchTextImpuritiesSuccess,
	searchTextChemicalProbesSuccess,

	historyList,

	linkersSimilarity,
	getStructureSearch,
	compoundsSimilarity,
	linkersSubstructure,
	linkersFullfragment,
	compoundsFullfragment,
	compoundsSubstructure,
	linkersSimilarityError,
	getStructureSearchError,
	linkersSubstructureError,
	compoundsSimilarityError,
	linkersFullfragmentError,
	linkersSimilaritySuccess,
	getStructureSearchSuccess,
	compoundsFullfragmentError,
	compoundsSubstructureError,
	linkersSubstructureSuccess,
	compoundsSimilaritySuccess,
	deleteItemStructureHistory,
	linkersFullfragmentSuccess,
	compoundsFullfragmentSuccess,
	compoundsSubstructureSuccess,

	handlerChangePageLib,
	handlerChangeTypeData,
	handlerChangePageDrugs,
	handlerChangePageCompound,
	handlerChangePageImpurities,
	handlerChangePageChemicalProbes,

	handlerChangeTypeStructure,
	handleChangeStructurePageEbc,
	updateHistoryStructureSearch,
	handlerChangePriceCartCompound,
	handleChangeStructurePageLinkers
} = searchSlice.actions;

export default searchSlice.reducer;
